import { MainLayout } from "../layouts";
import { Routes, Route, Navigate } from "react-router-dom";
import { AuthController, privateRoutes, publicRoutes } from ".";

export const Router = () => {
  return (
    <Routes>
      <Route>
        {publicRoutes.map((route, idx) => {
          return (
            <Route
              path={route.path}
              element={<div>{route.component}</div>}
              key={idx}
            />
          );
        })}
        <Route path="*" element={<Navigate to="/404" />} />
      </Route>

      <Route
        path=""
        element={<MainLayout />}
        children={
          <Route>
            {privateRoutes.map((route, key) => {
              return (
                <Route
                  path={route.path}
                  element={
                    <AuthController roles={route.roles}>
                    <>{route.component}</>
                    </AuthController>
                  }
                  key={key}
                />
              );
            })}
            <Route path="*" element={<Navigate to="/404" />} />
          </Route>
        }
      />
    </Routes>
  );
};
